import { useMemo } from 'react';

import { Control, Controller } from 'react-hook-form';

import { useTranslate } from '@i18n';
import { ToggleButtonCard, Stack, Text, u } from '@ui';

import { UserWelcomeWizardForm } from '../useUserWelcomeWizard';

import { optionGrid } from './CommonStyles.css';

type HandednessStepProps = {
    control: Control<UserWelcomeWizardForm>;
};

export const HandednessStep = ({ control }: HandednessStepProps) => {
    const t = useTranslate();

    const options = useMemo(
        () => [
            {
                value: 'right' as const,
                title: t('user_welcome_wizard.handedness_options_right_title'),
                description: t('user_welcome_wizard.handedness_options_right_description'),
            },
            {
                value: 'left' as const,
                title: t('user_welcome_wizard.handedness_options_left_title'),
                description: t('user_welcome_wizard.handedness_options_left_description'),
            },
        ],
        [t],
    );
    return (
        <Controller
            control={control}
            name="handedness"
            render={({ field }) => (
                <div className={optionGrid}>
                    {options.map((option) => (
                        <ToggleButtonCard
                            key={option.value}
                            value={option.value}
                            onClick={field.onChange}
                            isSelected={field.value === option.value}
                        >
                            <Stack gap={u(1)} alignItems="flex-start">
                                <Text variant="h3" color="inherit">
                                    {option.title}
                                </Text>
                                <Text variant="pSmall" color="inherit">
                                    {option.description}
                                </Text>
                            </Stack>
                        </ToggleButtonCard>
                    ))}
                </div>
            )}
        />
    );
};
